import { buildHtml, ContentRoute, RouteSlotInput } from '@caritas/ui';

import { isDefined } from '../../utils/is-defined';
import { mapImage } from '../Image.mappers';
import { buildCopyrightText, hasCaption } from './Image.mappers';

export function mapImageCarouselBlock(
  input: BlockImageCarouselFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'ImageCarousel'> {
  return {
    key: 'ImageCarousel',
    input: () => [
      {
        layout: input.layout || 'horizontal',
        images:
          input.images?.filter(isDefined).map((imageBlockItem) => {
            return {
              Description:
                imageBlockItem.displayDescription &&
                buildCopyrightText(imageBlockItem.image) !== ''
                  ? buildHtml(buildCopyrightText(imageBlockItem.image))
                  : undefined,
              Image: mapImage({
                image: imageBlockItem.image?.image,
                preset: 'carousel',
                caption:
                  imageBlockItem.displayDescription &&
                  hasCaption(imageBlockItem.image)
                    ? imageBlockItem.image.caption
                    : undefined,
              }),
              VerticalImage: mapImage({
                image: imageBlockItem.image?.image,
                preset: 'carousel_vertical',
                caption:
                  imageBlockItem.displayDescription &&
                  hasCaption(imageBlockItem.image)
                    ? imageBlockItem.image.caption
                    : undefined,
              }),
            };
          }) || [],
      },
      200,
    ],
  };
}
